

export const FETCH_LATEST_REQUEST = 'FETCH_LATEST_REQUEST';
export const FETCH_LATEST_SUCCESS = 'FETCH_LATEST_SUCCESS';
export const FETCH_LATEST_FAILURE = 'FETCH_LATEST_FAILURE';

export const fetchLatestRequest = () => {
  return{
    type: FETCH_LATEST_REQUEST
  };
};

export const fetchLatestSuccess = page => {
  return {
    type: FETCH_LATEST_SUCCESS,
    page
  };
};
export const fetchLatestFailure = error => {
  return {
    type: FETCH_LATEST_FAILURE,
    error
  };
};

export const fetchLatest = () => {
  return dispatch => {
    dispatch(fetchLatestRequest());
    return fetch(`${apiBase}/wp/v2/pages/2`)
      .then(response => response.json())
      .then(json => dispatch(fetchLatestSuccess(json)));
  };
};
